import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  senContactSubmissionDetails,
  sendBusinessServiceEnquiry,
  sendConsultingServiceEnquiry,
  sendImportExportServiceEnquiry,
  sendMedicalTourismServiceEnquiry,
  sendMigrationServiceEnquiry,
  sendPropertyManagementServiceEnquiry,
  sendRealEstateServiceEnquiry,
  sendRelocationSupportServiceEnquiry,
  sendResidenceServiceEnquiry,
  sendWorkAbroadServiceEnquiry,
} from "../thunks/services";

const servicesReducerInitialState = {
  isError: null,
  isLoading: false,
};

export const servicesReducer = createSlice({
  name: "servicesReducer",
  initialState: servicesReducerInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        sendImportExportServiceEnquiry.pending,
        sendMigrationServiceEnquiry.pending,
        sendResidenceServiceEnquiry.pending,
        sendBusinessServiceEnquiry.pending,
        sendRealEstateServiceEnquiry.pending,
        sendConsultingServiceEnquiry.pending,
        sendWorkAbroadServiceEnquiry.pending,
        sendPropertyManagementServiceEnquiry.pending,
        sendRelocationSupportServiceEnquiry.pending,
        sendMedicalTourismServiceEnquiry.pending,
        senContactSubmissionDetails.pending
      ),
      (state) => {
        state.isLoading = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        sendImportExportServiceEnquiry.rejected,
        sendMigrationServiceEnquiry.rejected,
        sendResidenceServiceEnquiry.rejected,
        sendBusinessServiceEnquiry.rejected,
        sendRealEstateServiceEnquiry.rejected,
        sendConsultingServiceEnquiry.rejected,
        sendWorkAbroadServiceEnquiry.rejected,
        sendPropertyManagementServiceEnquiry.rejected,
        sendRelocationSupportServiceEnquiry.rejected,
        sendMedicalTourismServiceEnquiry.rejected,
        senContactSubmissionDetails.rejected
      ),
      (state, action) => {
        state.isLoading = false;
        state.isError = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        sendImportExportServiceEnquiry.fulfilled,
        sendMigrationServiceEnquiry.fulfilled,
        sendResidenceServiceEnquiry.fulfilled,
        sendBusinessServiceEnquiry.fulfilled,
        sendRealEstateServiceEnquiry.fulfilled,
        sendConsultingServiceEnquiry.fulfilled,
        sendWorkAbroadServiceEnquiry.fulfilled,
        sendPropertyManagementServiceEnquiry.fulfilled,
        sendRelocationSupportServiceEnquiry.fulfilled,
        sendMedicalTourismServiceEnquiry.fulfilled,
        senContactSubmissionDetails.fulfilled
      ),
      (state) => {
        state.isLoading = false;
        state.isError = false;
      }
    );
  },
});
